import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tasks: [], // список задач
  selectedTask: null,
};

const tasksSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    addTask: (state, action) => {
      state.tasks.unshift(action.payload);
    },
    selectTask: (state, action) => {
      state.selectedTask = action.payload;
    },
    clearSelectedTask: (state) => {
      state.selectedTask = null;
    },
    // Добавляем setTasks для замены всего списка задач
    setTasks: (state, action) => {
      state.tasks = action.payload;
    },
    removeTask: (state, action) => {
      const taskId = action.payload;
      state.tasks = state.tasks.filter(task => task.id !== taskId);
    },
  },
});

export const {
  addTask,
  selectTask,
  clearSelectedTask,
  setTasks,
  removeTask
} = tasksSlice.actions;

export default tasksSlice.reducer;
